import React from 'react'
import ExceptionVariables from '../JSON Files/ExceptionVariables.json'
const XLSX = require("xlsx");
function AfterOptimizationTable({ salesAgg, resultValue, haloResults, filteredplotdata1, corevalue, distributionvalue, distributionvaluecontri, objectiveName }) {
  filteredplotdata1 = filteredplotdata1?.sort((a, b) => a.variable.localeCompare(b.variable))
  const hidingvariablelist = ExceptionVariables?.hiddenvariables;

  const downloadtabledata = () => {
    const data = [];

    const headers = [];

    //headers.push("Scenario")
    headers.push("Variables")
    headers.push("Planned")
    headers.push("Optimized")
    headers.push("Change(%)")
    headers.push("Unit")


    data.push(headers);
    const totalspends = [
      {
        variable: "Total Spends (Lacs)",
        planned_spends: (filteredplotdata1?.filter((it) => it.variable !== "sales")?.reduce((prev, next) => prev + next.planned_spends, 0) / 100000)?.toFixed(3),
        optimized_spends: (filteredplotdata1?.filter((it) => it.variable !== "sales")?.reduce((prev, next) => prev + next.optimized_spends, 0) / 100000)?.toFixed(3),
        percentage_difference: `${((
          (
            (filteredplotdata1
              ?.filter((it) => it.variable !== "sales")
              ?.reduce((prev, next) => prev + next.optimized_spends, 0) -
              filteredplotdata1
                ?.filter((it) => it.variable !== "sales")
                ?.reduce((prev, next) => prev + next.planned_spends, 0)
            ) /
            filteredplotdata1
              ?.filter((it) => it.variable !== "sales")
              ?.reduce((prev, next) => prev + next.planned_spends, 0)
          ) * 100)?.toFixed(3))}%`
      },


    ]
    const totalsales = [{
      variable: "Total Sales(Tonnes)",
      planned_spends: (salesAgg[0]?.planned_spends / 1000)?.toFixed(3),
      optimized_spends: (salesAgg[0]?.optimized_spends / 1000)?.toFixed(3),
      percentage_difference: ` ${((
        Number(salesAgg[0]?.optimized_spends) -
        Number(salesAgg[0]?.planned_spends))
        / salesAgg[0]?.planned_spends * 100)?.toFixed(3)
        }%`
    }]
    totalspends?.map((row) => {
      const variables = row.variable;
      const unit = "Lacs"
      const planned = row.planned_spends;
      const optimized = row.optimized_spends;
      const differencepercentage = row.percentage_difference;

      data.push([variables, planned, optimized, differencepercentage, unit]);
    })
    totalsales?.map((row) => {
      const variables = row.variable;
      const unit = "Kg Tonnes"
      const planned = row.planned_spends;
      const optimized = row.optimized_spends;
      const differencepercentage = row.percentage_difference;

      data.push([variables, planned, optimized, differencepercentage, unit]);
    })
    filteredplotdata1?.map((row) => {
      const variables = row.variable;
      const unit = "Lacs"
      const planned = (row.planned_spends / 100000).toFixed(3);
      const optimized = (row.optimized_spends / 100000).toFixed(3);
      const differencepercentage = `${row?.percentage_difference ? row?.percentage_difference?.toFixed(1) : row.planned_spends !== 0 ? ((row.optimized_spends - row.planned_spends) / (row.planned_spends) * 100).toFixed(1) : 0}%`;

      data.push([variables, planned, optimized, differencepercentage, unit]);
    })
    corevalue?.map((row) => {
      const variables = row.core_incremental_media;
      const unit = "Lacs"
      const planned = (row.planned_spends / 100000).toFixed(3);
      const optimized = (row.optimized_spends / 100000).toFixed(3);
      const differencepercentage = `${row?.percentage_difference ? row?.percentage_difference?.toFixed(1) : row.planned_spends !== 0 ? ((row.optimized_spends - row.planned_spends) / (row.planned_spends) * 100).toFixed(1) : 0}%`;

      data.push([variables, planned, optimized, differencepercentage, unit]);
    })

    distributionvalue?.length > 0 &&
      distributionvalue?.map((row) => {
        const variables = row.variable_name;
        const unit = "Number"
        const planned = row.attribute_value;
        const optimized = row.attribute_value;
        const differencepercentage = `${row?.percentage_difference ? row?.percentage_difference?.toFixed(1) : row !== 0 ? ((row.attribute_value - row.attribute_value) / (row.attribute_value) * 100).toFixed(1) : 0}%`;

        data.push([variables, planned, optimized, differencepercentage, unit]);
      })
    distributionvaluecontri?.length > 0 &&
      distributionvaluecontri?.map((row) => {
        const variables = row.variable_name;
        const unit = "Kg Tonnes"
        const planned = row.planned / 1000;
        const optimized = row.optimized / 1000;
        const differencepercentage = `${row?.percentage_difference ? row?.percentage_difference?.toFixed(1) : row.planned !== 0 ? ((row.optimized - row.planned) / (row.planned) * 100).toFixed(1) : 0}%`;
        // const brand= row.brand;
        //   const market = row.market;
        //   const lastfy = row.lastfy;
        //   const lastmape =`${(row.lastmape*100).toFixed(1)}%`;
        //   const currentfy =row.currentfy;
        //   const currentmape=`${(row.currentmape*100).toFixed(1)}%`;
        data.push([variables, planned, optimized, differencepercentage, unit]);
      })
    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Create a new worksheet and add data to it
    const worksheet = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Convert JSON to sheet and add as second sheet
    const worksheet2 = XLSX.utils.json_to_sheet(resultValue);
    XLSX.utils.book_append_sheet(workbook, worksheet2, "Scenario Comparison");

    // Write the workbook to binary Excel format
    const excelBuffer = XLSX.write(workbook, { type: "array", bookType: "xlsx" });

    // Create blob
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Trigger download
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `OptimizationResults.xlsx`;
    link.click();


  }
  return (
    <div className="accordion" id="accordionExample" style={{ userSelect: 'none' }}>
      <div className="accordion-item">
        <h2 className="accordion-header" id="headingOne">
          <button
            className="accordion-button"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseOne"
            aria-expanded="true"
            aria-controls="collapseOne"
          >
            Optimized Spend Summary for Objective : &nbsp;<strong>{objectiveName}</strong>
          </button>
        </h2>

        <div
          id="collapseOne"
          className="accordion-collapse collapse show"
          aria-labelledby="headingOne"
          data-bs-parent="#accordionExample"
        >
          <div className="accordion-body">
            <>
              {filteredplotdata1?.length > 0 &&

                <div className='d-flex flex-row gap-2'>
                  <button
                    className="btn btn-outline-secondary"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Download Excel"
                    onClick={downloadtabledata}>
                    <i className="mx-1 fa fa-download"></i>
                  </button>
                  <button
                    className="btn btn-outline-info"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Copy all tables with formatting"
                    onClick={() => {
                      const accordionBody = document.querySelector("#collapseOne .accordion-body");
                      if (accordionBody) {
                        const tables = accordionBody.querySelectorAll("table");
                        let htmlToCopy = "";

                        tables.forEach((table) => {
                          const clonedTable = table.cloneNode(true);

                          // Force header bold
                          const headers = clonedTable.querySelectorAll("thead th");
                          headers.forEach((th) => {
                            th.style.fontWeight = "bold";
                            th.style.backgroundColor = "#6c757d"; // Bootstrap secondary bg
                            th.style.color = "#fff"; // white text
                            th.style.border = "1px solid #000";
                            th.style.padding = "4px";
                          });

                          // Add cell borders & padding
                          const cells = clonedTable.querySelectorAll("td");
                          cells.forEach((td) => {
                            td.style.border = "1px solid #000";
                            td.style.padding = "4px";
                          });

                          // Add table border & spacing
                          clonedTable.style.borderCollapse = "collapse";
                          clonedTable.style.marginBottom = "20px";
                          clonedTable.style.width = "100%";

                          htmlToCopy += clonedTable.outerHTML + "<br/><br/>";
                        });

                        const blob = new Blob([htmlToCopy], { type: "text/html" });
                        const data = [new ClipboardItem({ "text/html": blob })];

                        navigator.clipboard.write(data).then(() => {
                          alert("All tables copied with formatting! Paste into Excel/Word.");
                        });
                      }
                    }}
                  >
                    <i className="mx-1 fa fa-copy"></i>
                  </button>
                </div>

              }
              <table className="container my-3 table table-striped table-bordered uniform-table" style={{ fontSize: "2vh" }}>
                <thead className="text-white bg-secondary ">
                  <th >Total</th>
                  <th className='text-center'>Planned  </th>
                  <th className='text-center'>Optimized   </th>
                  <th className='text-center'>Diff (%)</th>
                </thead>
                <tbody>

                  <tr >
                    <td className=" ">Total Spends (Lacs)</td>
                    <td className="text-center"> {
                      (filteredplotdata1?.filter((it) => it.variable !== "sales" && !it.variable.startsWith('Halo') && !it.variable.startsWith('HALO') && !it.variable.startsWith('halo')
                      )?.reduce((prev, next) => prev + next.planned_spends, 0) / 100000)?.toFixed(3)}</td>
                    <td className="text-center">{(
                      filteredplotdata1?.filter((it) => it.variable !== "sales" && !it.variable.startsWith('Halo') && !it.variable.startsWith('HALO') && !it.variable.startsWith('halo')
                      )?.reduce((prev, next) => prev + next.optimized_spends, 0) / 100000)?.toFixed(3)}</td>

                    <td className="text-center">
                      {((
                        (
                          (filteredplotdata1
                            ?.filter((it) => it.variable !== "sales")
                            ?.reduce((prev, next) => prev + next.optimized_spends, 0) -
                            filteredplotdata1
                              ?.filter((it) => it.variable !== "sales")
                              ?.reduce((prev, next) => prev + next.planned_spends, 0)
                          ) /
                          filteredplotdata1
                            ?.filter((it) => it.variable !== "sales")
                            ?.reduce((prev, next) => prev + next.planned_spends, 0)
                        ) * 100)?.toFixed(3))}%
                    </td>

                  </tr>
                  <tr >
                    <td className="">Total Sales (Tonnes)</td>

                    <td className="text-center">{(salesAgg[0]?.planned_sales / 1000)?.toFixed(3)}</td>
                    <td className="text-center">{(salesAgg[0]?.optimized_sales / 1000)?.toFixed(3)}</td>
                    <td className='text-center'>
                      {

                        ((
                          Number(salesAgg[0]?.optimized_sales) -
                          Number(salesAgg[0]?.planned_sales))
                          / salesAgg[0]?.planned_sales * 100)?.toFixed(3)
                      }%
                    </td>
                  </tr>

                </tbody>
              </table>
              {/* Variable Wise */}
              <table className="container my-3 table table-striped table-bordered uniform-table" style={{ fontSize: "2vh" }}>
                <thead className="text-white bg-secondary ">
                  <th >Variable</th>
                  <th className='text-center'>Planned</th>
                  <th className='text-center'>Optimized</th>
                  <th className='text-center'>Change(%)</th>
                </thead>

                <tbody>
                  {filteredplotdata1?.map((item) => {
                    return !hidingvariablelist.some((variable) => variable === item.variable) && item.variable !== "sales" 
                              && !item.variable.startsWith('Halo') && !item.variable.startsWith('HALO') && !item.variable.startsWith('halo') && <tr >
                      <td className={item.variable === "sales" ? "bg-success text-white " : " "}>{item?.variable}</td>
                      <td className={item.variable === "sales" ? "bg-success text-white text-center" : " text-center"}>{(item?.planned_spends / 100000?.toFixed(3))?.toLocaleString("en-IN")}</td>
                      <td className={item.variable === "sales" ? "bg-success text-white text-center" : " text-center"}>{(item?.optimized_spends / 100000?.toFixed(3))?.toLocaleString("en-IN")}</td>
                      <td className={item.variable === "sales" ? "bg-success text-white text-center" : " text-center"}>
                        {item?.percentage_difference ? item?.percentage_difference?.toFixed(1) : item.planned_spends !== 0 ? ((item.optimized_spends - item.planned_spends) / (item.planned_spends) * 100).toFixed(1) : 0}%
                      </td>
                    </tr>
                  })}
                </tbody>
              </table>

              {/*Core */}
              <table className="container my-3 table table-striped table-bordered uniform-table" style={{ fontSize: "2vh" }}>
                <thead className="text-white bg-secondary ">
                  <th >Variable</th>
                  <th className='text-center'>Planned</th>
                  <th className='text-center'>Optimized</th>
                  <th className='text-center'>Change(%)</th>
                </thead>

                <tbody>
                  {corevalue.length > 0 && corevalue?.map((item) => {
                    return !hidingvariablelist.some((variable) => variable === item.variable) && item.variable !== "sales" && <tr >
                      <td className={item.variable === "sales" ? "bg-success text-white " : " "}>{item?.core_incremental_media}</td>
                      <td className={item.variable === "sales" ? "bg-success text-white text-center" : " text-center"}>{(item?.planned_spends / 100000?.toFixed(3))?.toLocaleString("en-IN")}</td>
                      <td className={item.variable === "sales" ? "bg-success text-white text-center" : " text-center"}>{(item?.planned_spends / 100000?.toFixed(3))?.toLocaleString("en-IN")}</td>
                      <td className={item.variable === "sales" ? "bg-success text-white text-center" : " text-center"}>
                        {item?.percentage_difference ? item?.percentage_difference?.toFixed(1) : item.planned_spends !== 0 ? ((item.planned_spends - item.planned_spends) / (item.planned_spends) * 100).toFixed(1) : 0}%
                      </td>
                    </tr>
                  })}
                </tbody>
              </table>

              {/* Halo */}
              {haloResults?.length > 0 &&
                <table className="container my-3 table table-striped  table-bordered uniform-table" style={{ fontSize: "2vh" }}>
                  <thead className="text-white bg-secondary ">
                    <th >Variable</th>
                    <th className='text-center'>Planned</th>
                    <th className='text-center'>Optimized</th>
                    <th className='text-center'>Change(%)</th>
                  </thead>

                  <tbody>
                    {haloResults?.length > 0 &&
                      [haloResults.reduce((acc, item) => {
                        acc.planned_scenario += item.planned_scenario;
                        acc.optimized_scenario += item.optimized_scenario;
                        return acc;
                      }, {
                        variable: "HALO",
                        fy: haloResults[0].fy,
                        variable_type: "media",
                        planned_scenario: 0,
                        optimized_scenario: 0
                      })].map((item) => (
                        <tr key={item.variable}>
                          <td className={item.variable === "sales" ? "bg-success text-white " : ""}>
                            {item?.variable}
                          </td>
                          <td className={item.variable === "sales" ? "bg-success text-white text-center" : "text-center"}>
                            {(item?.planned_scenario / 100000).toFixed(3).toLocaleString("en-IN")}
                          </td>
                          <td className={item.variable === "sales" ? "bg-success text-white text-center" : "text-center"}>
                            {(item?.optimized_scenario / 100000).toFixed(3).toLocaleString("en-IN")}
                          </td>
                          <td className={item.variable === "sales" ? "bg-success text-white text-center" : "text-center"}>
                            {item?.percentage_difference
                              ? item?.percentage_difference?.toFixed(1)
                              : item.planned_scenario !== 0
                                ? (((item.optimized_scenario - item.planned_scenario) / item.planned_scenario) * 100).toFixed(1)
                                : 0
                            }%
                          </td>
                        </tr>
                      ))
                    }

                  </tbody>
                </table>}

              {/* Distribution */}
              {(distributionvalue?.length > 0 || distributionvaluecontri?.length > 0) &&
                <table className="container my-3 table table-striped  table-bordered uniform-table" style={{ fontSize: "2vh" }}>
                  <thead className="text-white bg-secondary ">
                    <th >Variable</th>
                    <th className='text-center'>Planned  </th>
                    <th className='text-center'>Optimized  </th>
                    <th className='text-center'>Change(%)</th>
                  </thead>

                  <tbody>
                    {distributionvalue?.length > 0 && distributionvalue?.map((item) => {
                      return !hidingvariablelist.some((variable) => variable === item.variable) && item.variable !== "sales" && <tr >
                        <td className={item.variable === "sales" ? "bg-success text-white " : " "}>{item?.variable_name}</td>
                        <td className={item.variable === "sales" ? "bg-success text-white text-center" : " text-center"}>{(item?.attribute_value?.toFixed(3))?.toLocaleString("en-IN")}</td>
                        <td className={item.variable === "sales" ? "bg-success text-white text-center" : " text-center"}>{(item?.attribute_value?.toFixed(3))?.toLocaleString("en-IN")}</td>
                        <td className={item.variable === "sales" ? "bg-success text-white text-center" : " text-center"}>
                          {item?.percentage_difference ? item?.percentage_difference?.toFixed(1) : item.attribute_value !== 0 ? ((item.attribute_value - item.attribute_value) / (item.attribute_value) * 100).toFixed(1) : 0}%
                        </td>
                      </tr>
                    })}
                    {distributionvaluecontri?.length > 0 && distributionvaluecontri?.map((item) => {
                      return !hidingvariablelist.some((variable) => variable === item.variable) && item.variable !== "sales" && <tr >
                        <td className={item.variable === "sales" ? "bg-success text-white " : " "}>{item?.variable_name}{" "}(Kg Tonnes)</td>
                        <td className={item.variable === "sales" ? "bg-success text-white text-center" : " text-center"}>{((item?.planned / 1000)?.toFixed(3))?.toLocaleString("en-IN")}</td>
                        <td className={item.variable === "sales" ? "bg-success text-white text-center" : " text-center"}>{((item?.optimized / 1000)?.toFixed(3))?.toLocaleString("en-IN")}</td>
                        <td className={item.variable === "sales" ? "bg-success text-white text-center" : " text-center"}>
                          {item?.percentage_difference ? item?.percentage_difference?.toFixed(1) : item.planned_spends !== 0 ? ((item.optimized - item.planned) / (item.planned) * 100).toFixed(1) : 0}%
                        </td>
                      </tr>
                    })}
                  </tbody>
                </table>
              }
            </>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AfterOptimizationTable